module.exports = __webpack_public_path__ + "static/assets/74b48d8638435d9e2f124d0061b257d8.svg";